import React, { useEffect, memo, useState } from "react";
import Service from "../services/service";
import Image from "./image";

const InstagramListFeedAPI = (props) => {

  const [data, setData] = useState(false);

  // useEffect(() => {
  //   Service.get(`${Service.api}/instagram/me/${props.id}`).then(resp => {
  //     setData(resp?.message?.data);
  //   });

  //   return () => {
  //       console.log('fim');
  //       setData(false);
  //     }
  // }, [])

  return (
      <div className="py-4 mb-5">
        <div className="text-center">
          <h3 className="barlow fw-bold">Odete e o meu Instagram</h3>
          <p className="text-muted">me acompanhe em <a name="instagramListFeed" id="instagramListFeed" href={`https://www.instagram.com/${props.username}`} target="_blank">@{props.username}</a></p>
        </div>
        <div id="instafeed" className="container" hidden>
          {data && data.length > 0 && data.filter(item => item.media_type === 'IMAGE').map((item, index) => {
            return (
              index < 9 && <Image src={item.media_url} key={item.id} />
            )
          })}
        </div>
      </div>
  );
};

export default memo(InstagramListFeedAPI);
